import { Directive } from '@angular/core';

/**
 * `<nz-input-number hcDecimalComma>`: a typed comma becomes a dot.
 *
 * The input of ng-zorro 19 knows only the dot («20.7»). Typing «20,» it parses 20 and rewrites the field to «20», so the comma
 * disappears under the cursor and «20,7» turns into «207». The help text of the nutrition fields says «20,7»,
 * and a Russian keyboard (the numeric pad too) gives a comma, so it is swapped before the input sees it.
 * `beforeinput` also covers soft keyboards; a pasted «20,7» is read by `parseDecimal` (`nzParser`).
 */
@Directive({
  selector: 'nz-input-number[hcDecimalComma]',
  host: { '(beforeinput)': 'onBeforeInput($event)' },
})
export class DecimalCommaDirective {
  onBeforeInput(event: InputEvent): void {
    const input = event.target;
    if (event.inputType !== 'insertText' || event.data !== ',' || !(input instanceof HTMLInputElement)) {
      return;
    }
    event.preventDefault();
    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? input.value.length;
    input.setRangeText('.', start, end, 'end');
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
